const Entity = `
  id
  name
  active
  user
  principle
  director
  assistant
  team
`;

export default Entity;
